import React from 'react'
import  Button  from '@material-ui/core/Button';
import { Input } from '@material-ui/core';
import "./Login.css"


function Login({email, setEmail, password, setPassword, signIn }) {
    return (
        <div>
            <form className="App_signup"> 

                <center>
                <img 
                className="app_headerImage"
                src ="https://www.instagram.com/static/images/web/mobile_nav_type_logo.png/735145cfe0a4.png"
                alt=""
                />
                </center>

                <Input 
                placeholder="email"
                type="text" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
                />
                <Input 
                placeholder="password"
                type="paswword" 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                />

                <Button type="submit" onClick={signIn}>Sign In</Button>
            </form>
        </div>
    )
}

export default Login
